(function () {
  function initMobileNavigation(scope) {
    var root = scope || document;
    var toggle = root.querySelector('[data-mobile-nav-toggle]');
    var nav = root.querySelector('[data-mobile-nav]');

    if (!toggle || !nav || toggle.dataset.initialized === 'true') return;

    toggle.dataset.initialized = 'true';
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
    var mediaButtons = Array.prototype.slice.call(root.querySelectorAll('[data-media-target]'));
    var galleryCurrent = root.querySelector('[data-gallery-current]');
    var variantSelect = root.querySelector('[data-variant-select]');
    var price = root.querySelector('[data-product-price]');
    var addToCart = root.querySelector('[data-add-to-cart]');
    var addToCartText = root.querySelector('[data-add-to-cart-text]');

    function pauseInactiveMedia(activeItem) {
      mediaItems.forEach(function (item) {
        if (item === activeItem) return;

        item.querySelectorAll('video').forEach(function (video) {
          video.pause();
        });

        item.querySelectorAll('model-viewer').forEach(function (model) {
          if (model.pause) model.pause();
        });
      });
    }

    function showMedia(mediaId, focusThumbnail) {
      if (!mediaId) return;

      var activeItem = null;

      mediaItems.forEach(function (item) {
        var isActive = item.dataset.mediaId === String(mediaId);
        item.hidden = !isActive;
        if (isActive) activeItem = item;
      });

      mediaButtons.forEach(function (button) {
        var isActive = button.dataset.mediaTarget === String(mediaId);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive) {
          if (galleryCurrent) galleryCurrent.textContent = button.dataset.mediaPosition;
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          if (focusThumbnail) button.focus({ preventScroll: true });
        }
      });

      if (activeItem) pauseInactiveMedia(activeItem);
    }

    mediaButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        showMedia(button.dataset.mediaTarget, false);
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var available = option.dataset.available === 'true';

        if (price && option.dataset.price) price.textContent = option.dataset.price;

        if (addToCart) {
          addToCart.disabled = !available;
          addToCart.setAttribute('aria-disabled', available ? 'false' : 'true');
        }

        if (addToCartText) {
          addToCartText.textContent = available ? 'Add to cart' : 'Sold out';
        }

        if (option.dataset.mediaId) {
          showMedia(option.dataset.mediaId, false);
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    }
  }

  function init(scope) {
    initMobileNavigation(scope);

    var root = scope || document;
    root.querySelectorAll('[data-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
